import { e as _inheritsLoose, a as _objectWithoutPropertiesLoose, f as _defineProperty } from './chunk-eb25cfa0.js';
import { ThemeProvider } from 'styled-components';
import './styled.js';
import { createElement, Component } from 'react';
import { object, func, oneOfType, node, bool } from 'prop-types';
import { Provider } from 'constate';

var Provider$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Provider$$1, _React$Component);

  function Provider$$1() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Provider$$1.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        theme = _this$props.theme,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["theme", "children"]);

    return createElement(Provider, props, theme ? createElement(ThemeProvider, {
      theme: theme
    }, children) : children);
  };

  return Provider$$1;
}(Component);

_defineProperty(Provider$1, "propTypes", {
  initialState: object,
  onMount: func,
  onUpdate: func,
  onUnmount: func,
  theme: oneOfType([object, func]),
  children: node,
  devtools: bool
});

_defineProperty(Provider$1, "defaultProps", {
  initialState: {}
});

export default Provider$1;
